export const engagementCampaignBannerClickDailyStatsCampaignId =
  "/engagement/campaign_banner_click_daily_stats/:campaign_id";
